import { NotificationsListType } from '../interfaces';
import { NotificationAPI } from '../api/notificationsAPI';
import { NotificationsList } from './notification-list/NotificationsList';

export function EnterpriseNotificationsList() {
  return (
    <NotificationsList
      dataSource={(payload, options) =>
        NotificationAPI.getEnterpriseNotifications(payload, options)
      }
      entity={NotificationsListType.ENTERPRISE}
    />
  );
}
